<template>
  <div>
    <div v-if="!release">
       <SuccessButton
            v-if="true /*$atividades.permissoes.includes(14)*/"
            :text="actionName"
            @func="abrirModal" 
            class="mb-0"
       />
    </div>
    <div v-else>
       <EditButton 
            v-if="true /*$atividades.permissoes.includes(14)*/"
            @func="abrirModal" 
       />
    </div>

    <SideBar
        :title="release ? 'Editar Release' : 'Cadastrar Release'"
        :active="active"
        @hide="fecharModal"
        @success="submit"
        :item="form"
        :textSucces="release ? 'Atualizar' : 'Cadastrar'"
        :disabled="true"
        size="large"
    >
    <div slot="body" id="modal-release-body" class="vs-con-loading__container">
         <vs-row>
            <vs-col vs-w="4" class="p-2">
               <vs-input 
                    label="Versão" 
                    v-model="form.versao" 
                    class="w-full"
                    v-validate="'required'"
                    name="versao"
                    placeholder="Ex: v6.1.0"
                />
               <span class="text-danger text-sm" v-show="errors.has('versao')">{{ errors.first('versao') }}</span>
            </vs-col>
            <vs-col vs-w="4" class="p-2">
               <vs-input 
                    type="date" 
                    label="Data Atualização" 
                    v-model="form.dataAtualizacao" 
                    class="w-full"
                />
            </vs-col>
         </vs-row>
         <vs-divider>Release Notes (Changelog)</vs-divider>
         <div class="px-2 mt-4">
             <quill-editor v-model="form.descricao" :options="editorOption" style="height: 300px; margin-bottom: 50px;"></quill-editor>
         </div>
      </div>
    </SideBar>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import components from "@/components/default/exports.js";

export default {
    name: "ModalRelease",
    props: {
        release: {
            type: Object,
            default: null,
        },
        actionName: {
            type: String,
            default: 'Cadastrar'
        }
    },
    components: {
        ...components,
        quillEditor
    },
    data() {
        return {
            active: false,
            form: {
                versao: '',
                dataAtualizacao: '',
                descricao: ''
            },
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'script': 'sub'}, { 'script': 'super' }],
                        [{ 'indent': '-1'}, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'font': [] }],
                        [{ 'align': [] }],
                        ['clean'],
                        ['link']
                    ]
                },
                placeholder: 'Escreva as notas da release aqui...'
            }
        };
    },
    methods: {
        deepClone(value) {
            if (Array.isArray(value)) {
                return value.map(item => this.deepClone(item));
            }

            if (value && typeof value === 'object') {
                return Object.keys(value).reduce((acc, key) => {
                    acc[key] = this.deepClone(value[key]);
                    return acc;
                }, {});
            }

            return value;
        },
        clonarRelease(release) {
            if (typeof structuredClone === 'function') {
                return structuredClone(release);
            }
            return this.deepClone(release);
        },
        limparLoadingModal() {
            this.$vs.loading.close('#modal-release-body > .con-vs-loading');
        },
        async abrirModal() {
            this.limparLoadingModal();
            this.active = true;
            try {
                if (this.release) {
                    this.form = this.clonarRelease(this.release);
                    if(this.form.dataAtualizacao) {
                        this.form.dataAtualizacao = this.form.dataAtualizacao.split('T')[0];
                    }
                } else {
                    this.resetForm();
                }
            } catch (error) {
                console.error(error);
                this.$vs.notify({
                    title: 'Erro',
                    text: 'Erro ao carregar dados do modal',
                    color: 'danger'
                });
            } finally {
                this.limparLoadingModal();
            }
        },
        fecharModal() {
            this.limparLoadingModal();
            this.active = false;
            this.resetForm();
        },
        resetForm() {
            this.form = {
                versao: '',
                dataAtualizacao: new Date().toISOString().split('T')[0],
                descricao: ''
            };
            this.$validator.reset();
        },
        async submit() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.$vs.loading();
                    try {
                        const payload = {
                            versao: this.form.versao,
                            dataAtualizacao: this.form.dataAtualizacao,
                            descricao: this.form.descricao,
                            idSistema: 1, // GSPro default system to satisfy backend restrictions
                            itens: [] // Ignored array
                        };
                    
                        let response;
                        if (this.release) {
                            response = await this.$http.put(`release/${this.release.id}`, payload);
                        } else {
                            response = await this.$http.post(`release`, payload);
                        }
                        
                        this.$vs.notify({
                            text: response.message || (this.release ? 'Release atualizada com sucesso' : 'Release cadastrada com sucesso'), 
                            color: 'success'
                        });

                        this.active = false;
                        this.$emit('update');
                    } catch (err) {
                        console.error(err);
                        let message = 'Erro ao salvar release';
                        if (err.response && err.response.data && err.response.data.message) {
                            message = err.response.data.message;
                        }
                        this.$vs.notify({title: 'Erro',text: message,color: 'danger'});
                    } finally {
                        this.$vs.loading.close();
                    }
                } else {
                    this.$vs.notify({text: 'Verifique os campos obrigatórios', color: 'warning'});
                }
            })
        },
        // async deleteRelease() {
        //     this.$vs.loading();
        //     try {
        //         await this.$http.delete(`release/${this.release.id}`);
        //         this.$vs.notify({text: 'Release excluída com sucesso', color: 'success'});
        //         this.active = false;
        //         this.$emit('update');
        //     } catch (err) {
        //         const error = this.$httpErrors(err);
        //         this.$vs.notify(error);
        //     } finally {
        //         this.$vs.loading.close();
        //     }
        // },
        // async toggleStatus() {
        //     this.$vs.loading();
        //     try {
        //         // Assuming endpoint functionality
        //         this.$vs.notify({text: 'Funcionalidade não implementada', color: 'warning'});
        //     } catch (error) {
        //         console.error(error);
        //     } finally {
        //         this.$vs.loading.close();
        //     }
        // }
    }
};
</script>
